





























import { createComponent, ref, computed, watch } from '@vue/composition-api';
import { Project } from '../models';

export default createComponent({
  name: 'Project',
  props: {
    project: { type: Object as () => Project, required: true },
  },
});
